import React, { SyntheticEvent } from 'react';
import { Badge } from 'features/catalog/useBadges';
import { talosBadgesLogoURL } from 'config/constants';
import './BadgeThumb.css';

type BadgeThumbSize = 'sm' | 'md' | 'lg';

interface BadgeThumbProps {
  badge: Badge;
  /** Image size / rarity icon scale. */
  size?: BadgeThumbSize;
  className?: string;
  imageClassName?: string;
  alt?: string;
  title?: string;
  /** When false, omit the hover rarity gem. Default true. */
  showRarity?: boolean;
}

const fallbackToLogo = (e: SyntheticEvent<HTMLImageElement>) => {
  if (e.currentTarget.src !== talosBadgesLogoURL) {
    e.currentTarget.src = talosBadgesLogoURL;
  }
};

/** Plain badge image that reveals rarity (top-left) on hover — same affordance as BadgeComponent. */
export const BadgeThumb: React.FC<BadgeThumbProps> = ({
  badge,
  size = 'md',
  className = '',
  imageClassName = '',
  alt = '',
  title,
  showRarity = true,
}) => (
  <span className={['badge-thumb', `badge-thumb--${size}`, className].filter(Boolean).join(' ')}>
    {showRarity ? (
      <img
        src={badge.rarityImageUrl}
        alt=""
        aria-hidden
        className={`badge-thumb-rarity glow-effect-${badge.rarityName}`}
        onError={fallbackToLogo}
      />
    ) : null}
    <img
      src={badge.smallImageUrl}
      alt={alt}
      title={title}
      className={['badge-thumb-image', imageClassName].filter(Boolean).join(' ')}
      onError={fallbackToLogo}
    />
  </span>
);
